import React,{useEffect} from 'react';
import styled from 'styled-components';
import { useSelector , useDispatch} from 'react-redux';
import { useParams } from 'react-router-dom';
import { startCase } from 'lodash';

import { Sequences } from './Sequences';
import { fetchSegment } from '../../../../actions/radminUploads';

const SequenceContainer = styled.div`
  width: 60%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const Overview = styled.div`
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  display: flex;
  margin-bottom: 30px;
  padding: 15px;
`;

Overview.Column = styled.div`
  flex: 1;
`;

Overview.Content = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

const Span = styled.span`
  color: #999;
`;

const SegmentConditionsIcon = () => {
  return (
    <svg
      width="34"
      height="29"
      viewBox="0 0 34 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 6.66667C6.66667 5.78261 7.01786 4.93477 7.64298 4.30964C8.2681 3.68452 9.11594 3.33333 10 3.33333C10.8841 3.33333 11.7319 3.68452 12.357 4.30964C12.9821 4.93477 13.3333 5.78261 13.3333 6.66667C13.3333 7.55072 12.9821 8.39857 12.357 9.02369C11.7319 9.64881 10.8841 10 10 10C9.11594 10 8.2681 9.64881 7.64298 9.02369C7.01786 8.39857 6.66667 7.55072 6.66667 6.66667ZM10 0C8.23189 0 6.5362 0.702379 5.28595 1.95262C4.03571 3.20286 3.33333 4.89856 3.33333 6.66667C3.33333 8.43478 4.03571 10.1305 5.28595 11.3807C6.5362 12.631 8.23189 13.3333 10 13.3333C11.7681 13.3333 13.4638 12.631 14.714 11.3807C15.9643 10.1305 16.6667 8.43478 16.6667 6.66667C16.6667 4.89856 15.9643 3.20286 14.714 1.95262C13.4638 0.702379 11.7681 0 10 0ZM23.3333 8.33333C23.3333 7.89131 23.5089 7.46738 23.8215 7.15482C24.134 6.84226 24.558 6.66667 25 6.66667C25.442 6.66667 25.866 6.84226 26.1785 7.15482C26.4911 7.46738 26.6667 7.89131 26.6667 8.33333C26.6667 8.77536 26.4911 9.19928 26.1785 9.51184C25.866 9.82441 25.442 10 25 10C24.558 10 24.134 9.82441 23.8215 9.51184C23.5089 9.19928 23.3333 8.77536 23.3333 8.33333ZM25 3.33333C23.6739 3.33333 22.4021 3.86012 21.4645 4.7978C20.5268 5.73548 20 7.00725 20 8.33333C20 9.65942 20.5268 10.9312 21.4645 11.8689C22.4021 12.8066 23.6739 13.3333 25 13.3333C26.3261 13.3333 27.5979 12.8066 28.5355 11.8689C29.4732 10.9312 30 9.65942 30 8.33333C30 7.00725 29.4732 5.73548 28.5355 4.7978C27.5979 3.86012 26.3261 3.33333 25 3.33333ZM0 20.8333C0 18.5333 1.86667 16.6667 4.16667 16.6667H15.8333C18.1333 16.6667 20 18.5333 20 20.8333V20.9933C19.9974 21.1148 19.9885 21.2361 19.9733 21.3567C19.944 21.6488 19.8939 21.9384 19.8233 22.2233C19.5999 23.1458 19.1978 24.0155 18.64 24.7833C17.2267 26.7267 14.5933 28.3333 10 28.3333C5.40667 28.3333 2.77333 26.7267 1.36 24.7833C0.629144 23.7743 0.170001 22.5943 0.0266667 21.3567C0.013271 21.2348 0.00437598 21.1125 0 20.99V20.8333ZM3.33333 20.92C3.34714 21.0953 3.37501 21.2692 3.41667 21.44C3.50667 21.8167 3.69 22.32 4.05667 22.8233C4.72333 23.7433 6.25667 25 10 25C13.74 25 15.2733 23.7433 15.9433 22.8233C16.3468 22.2643 16.5962 21.6091 16.6667 20.9233V20.8333C16.6667 20.6123 16.5789 20.4004 16.4226 20.2441C16.2663 20.0878 16.0543 20 15.8333 20H4.16667C3.94565 20 3.73369 20.0878 3.57741 20.2441C3.42113 20.4004 3.33333 20.6123 3.33333 20.8333V20.92ZM24.9967 26.6667C23.9506 26.677 22.9068 26.5652 21.8867 26.3333C22.4961 25.3712 22.9285 24.3078 23.1633 23.1933C23.68 23.28 24.2867 23.3333 24.9967 23.3333C27.9633 23.3333 29.09 22.4267 29.53 21.8767C29.7746 21.5722 29.9355 21.2091 29.9967 20.8233V20.8067C29.9897 20.5903 29.8989 20.3851 29.7434 20.2346C29.5878 20.084 29.3798 19.9999 29.1633 20H23.2867C23.1552 18.8072 22.7379 17.6637 22.07 16.6667H29.1667C31.4667 16.6667 33.3333 18.5333 33.3333 20.8333V20.89C33.3304 20.9936 33.3227 21.0971 33.31 21.2C33.1777 22.2087 32.7719 23.162 32.1367 23.9567C30.9067 25.49 28.7033 26.6667 25 26.6667H24.9967Z"
        fill="#00AEEF"
      />
    </svg>
  );
};

const TimeTriggerIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18ZM10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0ZM15 11.9L14.3 13.2L9 10.3V5H10.5V9.4L15 11.9Z"
        fill="black"
      />
    </svg>
  );
};

function AdditionalSegmentConditions({ data }) {
  return (
    <div>
      {data.map((segment, idx) => (
        <div key={idx}>
          <Span>{segment.condition}</Span> - {segment.cohortTitle}
        </div>
      ))}
    </div>
  );
}

export default function PreviewCampaignOverview() {
  const dispatch = useDispatch();
  const { id: campaignId } = useParams();
  const { additionalSegmentConditions, segment, timeTrigger } = useSelector(
    (state) => state.radAdmin.timeTriggerForm
  );
  const hasAdditionalSegments = additionalSegmentConditions.length > 0;

  useEffect(() => {
    if (!segment.cohortTitle) {
      dispatch(fetchSegment(campaignId))
    }
  }, [campaignId, dispatch, segment])

  return (
    <SequenceContainer>
      <Overview>
        <Overview.Column>
          <div>Trigger</div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TimeTriggerIcon />

            <div style={{ marginLeft: '15px', fontSize: '14px' }}>
              Time based
            </div>
          </div>

          <Overview.Content>
            {timeTrigger.daysOffset} days after{' '}
            {startCase(timeTrigger.dateAttribute)}{' '}
            {startCase(timeTrigger.frequency)}
          </Overview.Content>
        </Overview.Column>

        <Overview.Column>
          <div>Segment Conditions</div>

          <Overview.Content>
            <div style={{ display: 'flex' }}>
              <SegmentConditionsIcon />

              <div style={{ marginLeft: '15px' }}>
                {segment.cohortTitle && (
                  <div>
                    <Span>{segment.condition}</Span> - {segment.cohortTitle}
                  </div>
                )}

                {hasAdditionalSegments && (
                  <AdditionalSegmentConditions
                    data={additionalSegmentConditions}
                  />
                )}
              </div>
            </div>
          </Overview.Content>
        </Overview.Column>
      </Overview>

      <Sequences isPreviewMode={true} />
    </SequenceContainer>
  );
}
